import * as IconSelector from '../icons';

// Constantes exportadas
export const STATE_TASK_PENDIENTE = 'Pendiente';
export const STATE_TASK_POR_HACER = 'Por Hacer';
export const STATE_TASK_EN_CURSO = 'En Curso';
export const STATE_TASK_FINALIZADA = 'Finalizada';

// Definición del enum
export const statesTask = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido un estado para la tarea',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: STATE_TASK_PENDIENTE,
        label: 'Pendiente',
        description: 'tareas asignadas pendientes de planificar',
        icon: IconSelector.PendingIcon,
        color: 'Blue'
    },
    {
        value: STATE_TASK_POR_HACER,
        label: 'Por Hacer',
        description:
            'tareas asignadas planificadas y listas para su desarrollo',
        icon: IconSelector.TodoIcon,
        color: 'DarkRed'
    },
    {
        value: STATE_TASK_EN_CURSO,
        label: 'En Curso',
        description: 'tareas asignadas que estan siendo realizadas',
        icon: IconSelector.DoIcon,
        color: 'DarkOrange'
    },
    {
        value: STATE_TASK_FINALIZADA,
        label: 'Finalizada',
        description: 'tareas asignadas finalizdas y a la espera de validación',
        icon: IconSelector.DoneIcon,
        color: 'Green'
    }
];
